/* =====================================================
   ORDER & PROGRESS — CONTENT PAGE JS
   ===================================================== */

(function () {
  'use strict';

  // ---------- FILTER BAR ----------
  function initFilterBar() {
    const bar = document.querySelector('[data-op-filter-bar]');
    if (!bar) return;
    const tabs = bar.querySelectorAll('[data-op-filter]');
    const targets = document.querySelectorAll('[data-op-filter-target]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.opFilter;
        tabs.forEach((t) => {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        targets.forEach((target) => {
          const matches = filter === 'all' || target.dataset.opFilterTarget === filter;
          target.classList.toggle('is-hidden', !matches);
        });
      });
    });
  }

  // ---------- PODCAST RSS ----------
  const PROXIES = [
    { name: 'direct', build: (url) => url },
    { name: 'corsproxy.io', build: (url) => 'https://corsproxy.io/?' + encodeURIComponent(url) },
    { name: 'allorigins.win', build: (url) => 'https://api.allorigins.win/raw?url=' + encodeURIComponent(url) },
    { name: 'codetabs.com', build: (url) => 'https://api.codetabs.com/v1/proxy?quest=' + encodeURIComponent(url) },
    { name: 'thingproxy', build: (url) => 'https://thingproxy.freeboard.io/fetch/' + url },
  ];

  async function fetchRss(rssUrl) {
    console.log('[OP Podcast] Fetching RSS:', rssUrl);
    let lastError;
    for (let i = 0; i < PROXIES.length; i++) {
      const proxy = PROXIES[i];
      try {
        console.log('[OP Podcast] → Trying:', proxy.name);
        const res = await fetch(proxy.build(rssUrl), {
          headers: { Accept: 'application/xml, text/xml, */*' },
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const text = await res.text();
        if (text && (text.indexOf('<rss') !== -1 || text.indexOf('<feed') !== -1)) {
          console.log('[OP Podcast] ✅ Success via:', proxy.name);
          return text;
        }
        throw new Error('Invalid RSS response');
      } catch (err) {
        console.warn('[OP Podcast] ✗', proxy.name, 'failed:', err.message);
        lastError = err;
      }
    }
    throw lastError || new Error('All sources failed');
  }

  function parseRss(xmlText) {
    const xml = new DOMParser().parseFromString(xmlText, 'text/xml');
    if (xml.querySelector('parsererror')) throw new Error('XML parse error');
    const NS = 'http://www.itunes.com/dtds/podcast-1.0.dtd';
    const channel = xml.querySelector('channel');
    const channelImage =
      channel.getElementsByTagNameNS(NS, 'image')[0]?.getAttribute('href') ||
      channel.querySelector('image > url')?.textContent || '';
    const items = [...xml.querySelectorAll('item')];
    const total = items.length;
    const episodes = items.map((item, i) => {
      const epImage = item.getElementsByTagNameNS(NS, 'image')[0]?.getAttribute('href') || channelImage;
      const duration = item.getElementsByTagNameNS(NS, 'duration')[0]?.textContent || '';
      const author = item.getElementsByTagNameNS(NS, 'author')[0]?.textContent ||
        item.querySelector('author')?.textContent || '';
      const audioUrl = item.querySelector('enclosure')?.getAttribute('url') || '';
      const epNumber = item.getElementsByTagNameNS(NS, 'episode')[0]?.textContent || String(total - i);
      return {
        epNumber: epNumber.padStart(2, '0'),
        title: item.querySelector('title')?.textContent || '',
        link: item.querySelector('link')?.textContent || '',
        description: stripHtml(item.querySelector('description')?.textContent || ''),
        pubDate: item.querySelector('pubDate')?.textContent || '',
        duration: formatDuration(duration),
        image: epImage,
        audioUrl,
        guest: extractGuest(item.querySelector('title')?.textContent || '', author),
      };
    });
    return { channelImage, episodes };
  }

  function stripHtml(h) { const t = document.createElement('div'); t.innerHTML = h; return (t.textContent || t.innerText || '').trim(); }
  function formatDuration(d) {
    if (!d) return '';
    if (d.indexOf(':') !== -1) {
      const p = d.split(':').map(Number);
      if (p.length === 3) return `${p[0]} hr ${p[1]} min`;
      if (p.length === 2) return `${p[0]} min`;
      return d;
    }
    const s = parseInt(d, 10);
    if (isNaN(s)) return d;
    const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
    return h > 0 ? `${h} hr ${m} min` : `${m} min`;
  }
  function formatDate(p) { if (!p) return ''; const d = new Date(p); if (isNaN(d.getTime())) return p; return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); }
  function extractGuest(t, fb) { const m = t.match(/(?:w\/|with|feat\.?|featuring)\s+([^|]+?)$/i); if (m) return m[1].trim(); return fb || ''; }
  function cleanTitle(t) { return t.replace(/\s+(?:w\/|with|feat\.?|featuring)\s+.+$/i, '').trim(); }
  function escapeHtml(s) { if (!s) return ''; return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function escapeAttr(s) { return escapeHtml(s); }
  function truncate(s, m) { if (!s) return ''; return s.length > m ? s.substring(0, m).trim() + '…' : s; }
  function formatTime(s) { const m = Math.floor(s / 60); const sec = Math.floor(s % 60); return `${m}:${sec.toString().padStart(2, '0')}`; }

  const ICON_PLAY_16 = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>';
  const ICON_PAUSE_16 = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  const ICON_PLAY_10 = '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>';
  const ICON_PAUSE_10 = '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';

  // Episode state
  let allEpisodes = [];     // pool used on the page (size = totalCount)
  let listSize = 0;         // how many rows fit in the list
  let featuredIndex = 0;    // index of episode currently in featured card
  let currentAudio = null;
  let currentEpisodeIndex = -1;
  let timeUpdateHandler = null;
  let endedHandler = null;

  function renderFeatured(c, ep, isPlaying) {
    if (!ep) return;
    const playIcon = isPlaying ? ICON_PAUSE_16 : ICON_PLAY_16;
    c.innerHTML = `
      <div class="content-podcast__featured-media">
        ${ep.image ? `<img src="${escapeAttr(ep.image)}" alt="${escapeAttr(ep.title)}" loading="lazy">` : ''}
        ${ep.audioUrl ? `<button type="button" class="content-podcast__play-btn${isPlaying ? ' is-playing' : ''}" data-op-featured-toggle aria-label="Play episode"><span data-op-play-icon>${playIcon}</span></button>` : ''}
      </div>
      <div class="content-podcast__featured-body">
        <div class="content-podcast__featured-meta">
          <span class="tag tag--dark">EP. ${ep.epNumber}</span>
          ${ep.duration ? `<span class="content-podcast__duration"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>${escapeHtml(ep.duration)}</span>` : ''}
          ${ep.pubDate ? `<span class="content-podcast__date">· ${escapeHtml(formatDate(ep.pubDate))}</span>` : ''}
        </div>
        <h3 class="content-podcast__featured-title">${escapeHtml(cleanTitle(ep.title))}</h3>
        <p class="content-podcast__featured-desc">${escapeHtml(truncate(ep.description, 200))}</p>
        ${ep.guest ? `<p class="content-podcast__guest">with ${escapeHtml(ep.guest)}</p>` : ''}
        <div class="content-podcast__progress">
          <span class="content-podcast__progress-time" data-op-current>0:00</span>
          <div class="content-podcast__progress-bar"><div class="content-podcast__progress-fill" data-op-progress></div></div>
          <span class="content-podcast__progress-time content-podcast__progress-time--end">${ep.duration || '--:--'}</span>
        </div>
      </div>`;
  }

  /**
   * Build the rows list = all episodes EXCEPT the one currently featured.
   * Each row stores its original index in allEpisodes (data-op-row-index)
   * so clicking still resolves to the correct episode after re-render.
   */
  function renderRows(c) {
    const rows = [];
    for (let i = 0; i < allEpisodes.length; i++) {
      if (i === featuredIndex) continue;
      if (rows.length >= listSize) break;
      const ep = allEpisodes[i];
      rows.push(`
        <button type="button" class="content-podcast__row" data-op-row-index="${i}" ${ep.audioUrl ? `data-op-audio="${escapeAttr(ep.audioUrl)}"` : ''}>
          <div class="content-podcast__col-num"><span class="content-podcast__row-num" data-op-play-icon>${ICON_PLAY_10}</span></div>
          <div class="content-podcast__col-ep content-podcast__row-ep">
            <div class="content-podcast__row-thumb">${ep.image ? `<img src="${escapeAttr(ep.image)}" alt="" loading="lazy">` : ''}</div>
            <div class="content-podcast__row-text">
              <p class="content-podcast__row-title">${escapeHtml(cleanTitle(ep.title))}</p>
              <p class="content-podcast__row-ep-num">EP. ${escapeHtml(ep.epNumber)}</p>
            </div>
          </div>
          <div class="content-podcast__col-guest content-podcast__row-guest">${escapeHtml(ep.guest)}</div>
          <div class="content-podcast__col-date content-podcast__row-date">${escapeHtml(formatDate(ep.pubDate))}</div>
          <div class="content-podcast__col-time content-podcast__row-time">${escapeHtml(ep.duration)}</div>
        </button>`);
    }
    c.innerHTML = rows.join('');
  }

  function updateFeaturedPlayIcon(section, isPlaying) {
    const btn = section.querySelector('[data-op-featured-toggle]');
    if (!btn) return;
    const icon = btn.querySelector('[data-op-play-icon]');
    if (icon) icon.innerHTML = isPlaying ? ICON_PAUSE_16 : ICON_PLAY_16;
    btn.classList.toggle('is-playing', isPlaying);
  }

  function updateProgressUI(featuredEl) {
    if (!currentAudio || !featuredEl) return;
    const pf = featuredEl.querySelector('[data-op-progress]');
    const ct = featuredEl.querySelector('[data-op-current]');
    if (!currentAudio.duration) return;
    const pct = (currentAudio.currentTime / currentAudio.duration) * 100;
    if (pf) pf.style.width = pct + '%';
    if (ct) ct.textContent = formatTime(currentAudio.currentTime);
  }

  function clearAudioListeners() {
    if (currentAudio) {
      if (timeUpdateHandler) currentAudio.removeEventListener('timeupdate', timeUpdateHandler);
      if (endedHandler) currentAudio.removeEventListener('ended', endedHandler);
    }
    timeUpdateHandler = null;
    endedHandler = null;
  }

  function rebuildAudio(ep, featuredEl, section) {
    clearAudioListeners();
    if (currentAudio) {
      currentAudio.pause();
      currentAudio = null;
    }
    currentAudio = new Audio(ep.audioUrl);

    timeUpdateHandler = () => updateProgressUI(featuredEl);
    endedHandler = () => {
      updateFeaturedPlayIcon(section, false);
      const pf = featuredEl.querySelector('[data-op-progress]');
      const ct = featuredEl.querySelector('[data-op-current]');
      if (pf) pf.style.width = '0%';
      if (ct) ct.textContent = '0:00';
    };
    currentAudio.addEventListener('timeupdate', timeUpdateHandler);
    currentAudio.addEventListener('ended', endedHandler);
  }

  function selectEpisode(index, section, featuredEl, rowsEl, autoplay) {
    if (index < 0 || index >= allEpisodes.length) return;
    const ep = allEpisodes[index];
    if (!ep || !ep.audioUrl) return;

    const isSameEpisode = currentEpisodeIndex === index && currentAudio;

    if (featuredIndex !== index) {
      // Episode swap → re-render featured AND list (so the old featured
      // joins the list, and the new featured leaves the list).
      featuredIndex = index;
      renderFeatured(featuredEl, ep, false);
      renderRows(rowsEl);
    }

    if (isSameEpisode) {
      if (currentAudio.paused) {
        currentAudio.play().catch((err) => {
          console.warn('[OP Audio]', err);
          updateFeaturedPlayIcon(section, false);
        });
        updateFeaturedPlayIcon(section, true);
      } else {
        currentAudio.pause();
        updateFeaturedPlayIcon(section, false);
      }
    } else {
      rebuildAudio(ep, featuredEl, section);
      currentEpisodeIndex = index;
      if (autoplay) {
        currentAudio.play().catch((err) => {
          console.warn('[OP Audio]', err);
          updateFeaturedPlayIcon(section, false);
        });
        updateFeaturedPlayIcon(section, true);
      }
    }
  }

  async function initPodcast() {
    console.log('[OP Podcast] Init...');
    const section = document.querySelector('[data-op-podcast]');
    if (!section) return;

    const rssUrl = section.dataset.rssUrl || section.getAttribute('data-rss-url');
    if (!rssUrl) { console.warn('[OP Podcast] No RSS URL'); return; }

    const totalCount = parseInt(section.dataset.episodesCount, 10) || 12;
    listSize = Math.max(1, totalCount - 1);
    console.log('[OP Podcast] RSS:', rssUrl, '— show', totalCount, 'episodes (1 featured +', listSize, 'in list)');

    const featuredEl = section.querySelector('[data-op-podcast-featured]');
    const rowsEl = section.querySelector('[data-op-podcast-rows]');
    const errorEl = section.querySelector('[data-op-podcast-error]');

    try {
      const xml = await fetchRss(rssUrl);
      const { episodes } = parseRss(xml);
      if (!episodes.length) throw new Error('No episodes found');

      // Pool: totalCount episodes (featured + 1 buffer = listSize + 1, but we
      // grab up to totalCount so swapping has room).
      allEpisodes = episodes.slice(0, totalCount);
      featuredIndex = 0;

      renderFeatured(featuredEl, allEpisodes[0], false);
      renderRows(rowsEl);

      section.addEventListener('click', (e) => {
        const featuredBtn = e.target.closest('[data-op-featured-toggle]');
        if (featuredBtn) {
          e.preventDefault();
          selectEpisode(featuredIndex, section, featuredEl, rowsEl, true);
          return;
        }

        const row = e.target.closest('[data-op-row-index]');
        if (row) {
          e.preventDefault();
          const index = parseInt(row.dataset.opRowIndex, 10);
          if (!isNaN(index)) {
            selectEpisode(index, section, featuredEl, rowsEl, true);
            const rect = featuredEl.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > window.innerHeight) {
              featuredEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
      });
    } catch (err) {
      console.error('[OP Podcast] ❌ Failed:', err);
      if (featuredEl) featuredEl.style.display = 'none';
      if (rowsEl && rowsEl.parentElement) rowsEl.parentElement.style.display = 'none';
      if (errorEl) errorEl.hidden = false;
    }
  }

  function initReveal() {
    const els = document.querySelectorAll('[data-op-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-revealed')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
    els.forEach((e) => io.observe(e));
  }

  function boot() {
    console.log('[OP] Boot');
    initFilterBar();
    initReveal();
    initPodcast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();